import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { catchError, Observable, switchMap, throwError, of } from "rxjs";
import { inject } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { TokenService } from "./token.service";

export const AuthInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  if (!req.url.includes("gestion") || req.url.includes("login") || req.url.includes("refresh")) {
    return next(req);
  }

  const cookieService = inject(CookieService);
  const tokenService = inject(TokenService);
  const orderTokenBoGestion = cookieService.get("orderTokenBoGestion");

  const clonedRequest = req.clone({
    setHeaders: {
      Authorization: `Bearer ${orderTokenBoGestion}`
    }
  });

  let isRefreshing = false;
  let failedRequestQueue: ((retryRequest: HttpRequest<unknown>) => void)[] = [];

  const handleRequest = (clonedReq: HttpRequest<unknown>): Observable<HttpEvent<unknown>> => {
    return next(clonedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !isRefreshing) {
          // On refresh le token et on reprend la requête
          isRefreshing = true;

          return tokenService.refreshToken().pipe(
            switchMap(({ token }) => {
              const retryRequest = clonedReq.clone({
                setHeaders: {
                  Authorization: `Bearer ${token}`
                }
              });
              isRefreshing = false;
              // Ré-exécuter toutes les requêtes échouées dans la queue
              failedRequestQueue.forEach((req) => req(retryRequest));
              failedRequestQueue = [];
              return next(retryRequest);
            }),
            catchError(err => {
              isRefreshing = false;
              return throwError(() => err); // Propagate error if refresh fails
            })
          );
        }

        if (error.status === 401 && isRefreshing) {
          // Si une autre requête a déjà été lancée pour le refresh token
          return new Observable<HttpEvent<unknown>>(observer => {
            failedRequestQueue.push((retryRequest: HttpRequest<unknown>) => {
              // N'envoyez pas l'observable, mais la réponse de `next()`
              next(retryRequest).subscribe({
                next: (event) => observer.next(event), // Transmettre l'événement
                complete: () => observer.complete() // Compléter l'observable
              });
            });
          });
        }

        return throwError(() => error); // Si l'erreur est autre qu'un 401
      })
    );
  };

  return handleRequest(clonedRequest);
};
